<template>
<div>
  <el-button style="width:100%;" type="secondary" size="small" @click="open">수집/판단 설정</el-button>
  <w-sliding-popup ref="slidingPopup" :title="`[${objInfo.label}] 수집/판단 정책 개별 설정`" top="50px" width="1000px" @close="close" :appendToBody="true">
    <div slot="content">
      <el-row type="flex" justify="space-between">
        <div class="title-h3">수집/판단 목록</div>
        <div class="vertical-center-box">
          <w-obj-rsc-key-manage-popup class="mr-r5" :obj-info="objInfo" :agent-obj-id="agentObjId"></w-obj-rsc-key-manage-popup>
          <w-obj-rsc-key-setting-popup :obj-info="objInfo" :agent-obj-id="agentObjId"></w-obj-rsc-key-setting-popup>
        </div>
      </el-row>
      <hr class="mr-b20" style="margin-top: 10px" />
      <el-row class="title-bar">
        <el-col :span="20">
          <el-select v-show="managetypeId=='NMS'||managetypeId=='FMS'||managetypeId=='DBMS'||managetypeId=='VMS'" v-model="managetypeKey" style="width:140px;">
            <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.label" :value="item.managetypeKey"></el-option>
          </el-select>
          <el-radio-group class="ordinary" v-model="resourceType" @change="loadData" size="mini">
            <el-radio-button label="RSCTYPE">자원구분</el-radio-button>
            <el-radio-button label="RSC">자원</el-radio-button>
          </el-radio-group>
          <el-select v-show="managetypeId === 'E2E'" v-model="agentObjId">
            <el-option v-for="agent in agentList" :key="agent.agentId" :label="agent.objName" :value="agent.objId" />
          </el-select>
          <el-button v-show="resourceType == 'RSC'" @click="deleteIndividualRscRule" style="height:28px" :disabled="checkedRscRow.length == 0">정책복원</el-button>
          <el-button v-show="resourceType == 'RSC'" type="primary" @click="applyIndividualRscRule" style="height:28px;margin-left:0px!important" :disabled="checkedRscRow.length == 0">정책으로 저장</el-button>
        </el-col>
        <el-col :span="4">
          <el-row type="flex" justify="end">
            <el-button class="mr-r4" size="small" @click="exportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
            <w-header-search-button @click="setSearchToolVisible"></w-header-search-button>
          </el-row>
        </el-col>
      </el-row>
      <!-- 자원구분 -->
      <el-table-wrapper v-loading="rsctypeLoading" :element-loading-text="rsctypeLoadingText" v-show="resourceType == 'RSCTYPE'" :data="ruleRsctypeTableData" :columns="ruleRsctypeTableColumn" :column-default="columnDefault" ref="ruleRsctypeTable" style="width:100%;"
        :show-search-tool="showSearchTool" :show-custom-header="true" remote :pagination="true" :total="rsctypeTotal" @condition-change="loadData">
        <template slot-scope="scope" slot="status-slot">
          <span v-show="scope.row.applyFlag == 'Y'"><i class="fas fa-circle text-mini state-normal" /></span>
          <span v-show="scope.row.applyFlag == 'N'"> <i class="fas fa-circle text-mini state-none" /></span>
        </template>
      </el-table-wrapper>
      <!-- 자원 -->
      <el-table-wrapper v-loading="rscLoading" ref="ruleRscTable" :element-loading-text="rscLoadingText" v-show="resourceType == 'RSC'" :data="ruleRscTableData" :columns="ruleRscTableColumn" :column-default="columnDefault" highlight-current-row style="width:100%;"
        :show-search-tool="showSearchTool" show-custom-header row-class-name="c-dblclick" @row-dblclick="dblclickRow" @selection-change="changeCheckedRscRow"
        remote :pagination="true" :total="rscTotal" @condition-change="loadData">
        <template slot-scope="scope" slot="status-slot">
            <span v-show="scope.row.status == 'Y'"><i class="fas fa-circle text-mini state-normal" /></span>
            <span v-show="scope.row.status == 'N'"> <i class="fas fa-circle text-mini state-none"/></span>
          </template>
      </el-table-wrapper>
      <w-update-rule-rsctype-popup ref="updateRuleRsctypePopup" :update-row="updateRow" :managetype-id="managetypeId" :managetype-key="managetypeKey" @re-load="loadData"></w-update-rule-rsctype-popup>
      <w-update-rule-rsc-popup ref="updateRuleRscPopup" :update-row="updateRow" :managetype-id="managetypeId" :managetype-key="managetypeKey" @re-load="loadData" :obj-info="objInfo"></w-update-rule-rsc-popup>
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
import { cloneDeep, isNil, isEqual } from 'lodash';
import { isEmpty } from '@/utils/basic';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { MANAGETYPE_KEY } from '@/constants/managetype-key';
import FileApi from '@/api/common/file';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';
import WUpdateRuleRsctypePopup from '@/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/popup/UpdateRuleRsctypePopup';
import WUpdateRuleRscPopup from '@/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/popup/UpdateRuleRscPopup';
import WObjRscKeySettingPopup from './ObjRscKeySettingPopup';
import WObjRscKeyManagePopup from './ObjRscKeyManagePopup';

export default {
  name: 'WCollectionJudgementRulePopupButton',
  components: {
    WUpdateRuleRsctypePopup,
    WUpdateRuleRscPopup,
    WObjRscKeySettingPopup,
    WObjRscKeyManagePopup,
  },
  props: {
    objInfo: Object,
  },
  data() {
    return {
      rsctypeLoading: false,
      rsctypeLoadingText: null,
      rsctypeTotal: 0,
      rscLoading: false,
      rscLoadingText: null,
      rscTotal: 0,
      managetypeId: null,
      managetypeKey: null,
      managetypeIdKey: null,
      managetypeKeyList: [],
      title: null,
      resourceType: 'RSCTYPE',
      showSearchTool: false,
      checkedRscRow: [],
      updateRow: null,
      ruleRsctypeTableData: [],
      ruleRscTableData: [],
      columnDefault,
      ruleRsctypeTableColumn: [
        {
          prop: 'applyFlag',
          label: '적용',
          width: 75,
          scopedSlot: 'status-slot',
          filters: [
            {
              text: '적용',
              value: 'Y',
            },
            {
              text: '해제',
              value: 'N',
            },
          ],
        },
        {
          prop: 'rsctypeId',
          label: '자원구분 ID',
          searchable: true,
        },
        {
          prop: 'rsctypeName',
          label: '자원구분명',
          searchable: true,
        },
        {
          prop: 'rscGetinterval',
          label: '수집 주기(초)',
          width: 90,
          searchable: true,
        },
        {
          prop: 'eventRscGetintervalName',
          label: '이벤트 판단 주기',
          searchable: true,
        },
        {
          prop: 'eventJudgeCount',
          label: '판단 횟수',
          width: 80,
          searchable: true,
        },
        {
          prop: 'rscGetmethodName',
          label: '수집 방식',
          searchable: true,
        },
      ],
      ruleRscTableColumn: [
        {
          type: 'selection',
          width: 50,
        },
        {
          prop: 'status',
          label: '개별설정',
          headerAlign: 'center',
          align: 'center',
          scopedSlot: 'status-slot',
          width: 75,
          filters: [
            {
              text: '개별',
              value: 'Y',
            },
            {
              text: '정책',
              value: 'N',
            },
          ],
        },
        {
          prop: 'rsctypeName',
          label: '자원구분명',
          searchable: true,
        },
        {
          prop: 'rscId',
          label: '자원 ID',
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원명',
          searchable: true,
        },
        {
          prop: 'rscUnit',
          label: '자원단위',
          searchable: true,
          width: 60,
        },
        {
          prop: 'eventJudgeConditionTypeName',
          label: '이벤트 판단 타입',
          searchable: true,
          width: 100,
        },
        {
          prop: 'rscGetmethodName',
          label: '수집 방식',
          searchable: true,
        },
      ],
      agentList: [],
      agentObjId: null,
    };
  },
  watch: {
    managetypeId: {
      handler(value) {
        if (!isNil(value)) {
          if (isEqual(value, 'NMS') || isEqual(value, 'FMS') || isEqual(value, 'DBMS') || isEqual(value, 'VMS')) {
            this.managetypeKeyList = MANAGETYPE_KEY[value];
            this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
          } else {
            this.managetypeKey = '_';
          }
          this.managetypeIdKey = `${value}.${this.managetypeKey}`;
        }
      },
    },
    managetypeKey: {
      handler(value) {
        const managetypeId = this.managetypeId;
        this.managetypeIdKey = `${managetypeId}.${value}`;
      },
    },
    managetypeIdKey: {
      handler() {
        if (!isNil(this.managetypeId) && !isNil(this.managetypeKey)) {
          this.loadRuleData();
        }
      },
    },
    /**
     * e2e 에이전트 변경할 때마다 자원구분/자원 재로드
     * @return {[type]}       [description]
     * @author jda
     */
    agentObjId(objId) {
      if (isEmpty(objId)) {
        return;
      }
      this.loadData();
    },
  },
  methods: {
    open() {
      const obj = this.objInfo.obj;
      const managetypeId = obj.objManagetypeId;
      this.managetypeId = managetypeId;
      this.$refs.slidingPopup.visible = true;

      // e2e트랜잭션 서비스일 경우 에이전트 정보를 가져온다.
      if (managetypeId === 'E2E') {
        RuleSettingsAPI.getAgentByTransactionService({
          objId: obj.objId,
        }).then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.agentList = result;
            this.agentObjId = result.length > 0 ? result[0].objId : null;
          } else {
            this.agentList = [];
            this.agentObjId = null;
          }
        });
      }
    },
    close() {
      this.managetypeId = null;
      this.managetypeKey = null;
      this.managetypeIdKey = null;
      this.resourceType = 'RSCTYPE';
      this.ruleRsctypeTableData = [];
      this.ruleRscTableData = [];
      this.agentObjId = null;
      this.$refs.ruleRsctypeTable.clearFilter();
      this.$refs.ruleRscTable.clearFilter();
      this.showSearchTool = false;
      this.rsctypeLoading = false;
      this.rscLoading = false;
    },
    loadRuleData() {
      const table = isEqual(this.resourceType, 'RSCTYPE') ? this.$refs.ruleRsctypeTable : this.$refs.ruleRscTable;
      if (table) {
        this.loadData();
      } else {
        this.$nextTick(() => {
          this.loadData();
        });
      }
    },
    loadData() {
      if (this.managetypeId === 'E2E' && isEmpty(this.agentObjId)) {
        return;
      }
      const params = this.getParameter();
      if (isEqual(this.resourceType, 'RSCTYPE')) {
        this.rsctypeLoadingText = null;
        this.rsctypeLoading = true;
        RuleSettingsAPI.getRuleRsctypeList(params)
          .then((response) => {
            if (response.data.success) {
              this.ruleRsctypeTableData = cloneDeep(response.data.data);
              this.rsctypeTotal = response.data.total;
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 설정', false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 설정', false));
          })
          .finally(() => {
            this.rsctypeLoading = false;
          });
      } else {
        this.rscLoadingText = null;
        this.rscLoading = true;
        RuleSettingsAPI.getRuleRscList(params)
          .then((response) => {
            if (response.data.success) {
              this.ruleRscTableData = cloneDeep(response.data.data);
              this.rscTotal = response.data.total;
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 설정', false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 설정', false));
          })
          .finally(() => {
            this.rscLoading = false;
          });
      }
    },
    /**
     * 정책 조회를 위한 파라미터 객체를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getParameter() {
      const managetypeId = this.managetypeId;
      const managetypeKey = this.managetypeKey;
      const objId = managetypeId === 'E2E' ? this.agentObjId : this.objInfo.obj.objId;
      const tableParams = isEqual(this.resourceType, 'RSCTYPE') ? this.$refs.ruleRsctypeTable.getParameter() : this.$refs.ruleRscTable.getParameter();
      return {
        managetypeId,
        managetypeKey,
        objId,
        ...tableParams,
      };
    },
    dblclickRow(row) {
      this.updateRow = cloneDeep(row);
      if (isEqual(this.resourceType, 'RSCTYPE')) {
        this.$refs.updateRuleRsctypePopup.$refs.slidingPopup.visible = true;
      } else {
        this.$refs.updateRuleRscPopup.$refs.slidingPopup.visible = true;
      }
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    changeCheckedRscRow(selection) {
      this.checkedRscRow = selection;
    },
    /**
     * 정책복원 버튼 선택시 수행
     */
    deleteIndividualRscRule() {
      const obj = this.objInfo.obj;
      const objId = obj.objManagetypeId === 'E2E' ? this.agentObjId : obj.objId;
      const rscGetdataSourceObjList = this.checkedRscRow;
      const params = {
        objId,
        rscGetdataSourceObjList,
      };
      this.$confirm(...msgUtil.getCustomConfirmData('정책 설정 값으로 복원하시겠습니까?')).then(() => {
        RuleSettingsAPI.deleteIndividualRscRuleList(params).then((response) => {
          if (response.data.success) {
            this.loadData();
            this.$message(msgUtil.getResultMsgData(msgUtil.action.APPLY, '복원', true));
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.APPLY, '복원', false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.APPLY, '복원', false));
        });
      });
    },
    applyIndividualRscRule() {
      const checkedRscRow = this.checkedRscRow;
      RuleSettingsAPI.applyIndividualRscRuleList(checkedRscRow).then((response) => {
        if (response.data.success) {
          this.loadData();
          this.$message(msgUtil.getCustomResultMsgData('정책으로 저장하였습니다.', true));
        } else {
          this.$message(msgUtil.getCustomResultMsgData('정책 저장에 실패하였습니다.', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getCustomResultMsgData('정책 저장에 실패하였습니다.', false));
      });
    },
    /**
     * 조회한 정책 정보를 엑셀 파일로 출력한다.
     * @author Ju
     * @return {[type]} [description]
     */
    exportExcel() {
      const params = this.getParameter();
      delete params.start;
      delete params.limit;

      let excelFunction;
      if (isEqual(this.resourceType, 'RSCTYPE')) {
        excelFunction = RuleSettingsAPI.createRuleRsctypeExcel;
        this.rsctypeLoadingText = '엑셀 출력 중..';
        this.rsctypeLoading = true;
      } else {
        excelFunction = RuleSettingsAPI.createRuleRscExcel;
        this.rscLoadingText = '엑셀 출력 중..';
        this.rscLoading = true;
      }
      excelFunction(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        })
        .finally(() => {
          if (isEqual(this.resourceType, 'RSCTYPE')) {
            this.rsctypeLoadingText = null;
            this.rsctypeLoading = false;
          } else {
            excelFunction = RuleSettingsAPI.createRuleRscExcel;
            this.rscLoadingText = null;
            this.rscLoading = false;
          }
        });
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/CollectionJudgementRulePopupButton.vue